<div id="continueLater" class="container mx-auto" data-cy="continue-later">
  <div class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.technicalDetails.steps.continueLater.title' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>

    <p
      class="text-left sm:text-center email-fill mb-16 leading-10"
      [innerHTML]="
        'modules.evcQuote.steps.technicalDetails.steps.continueLater.description' | translate: { '@email': email }
      "
    ></p>

    <div class="sm:mx-auto flex flex-col sm:max-w-max">
      <button class="btn-primary sm:mx-4" (click)="resendEmail()">
        {{ "modules.evcQuote.steps.technicalDetails.steps.continueLater.sendAgain" | translate }}
      </button>

      <ife-navigation [showNext]="false" [showPrevious]="true" (previousStep)="navigateBack()"> </ife-navigation>
    </div>
  </div>
</div>
